import { ContentBlocks } from "../../blocks"
import { PageHeader } from "../../pageHeader"
import { FooterCTA } from "../../footerCTA"

export const Landing = ({ entry }) => {
  return (
    <>
      <PageHeader {...entry} />

      {entry?.contentBlocks?.length > 0 && (
        <ContentBlocks blocks={entry.contentBlocks} />
      )}

      {entry?.footerCTA?.length > 0 && (
        <FooterCTA
          ctaHeading={entry.footerCTA[0].ctaHeading}
          ctaLink={entry.footerCTA[0].ctaLink}
        />
      )}
    </>
  )
}
